import withAuthentication from '@t7x000/apex-web/lib/hocs/withAuthentication';
import React from 'react';
import PageFooterLayout from '../layouts/PageFooterLayout/PageFooterLayout';
import { getBEMClasses } from '../helpers/cssClassesHelper';

import MarketDataCardsContainer from '@t7x000/apex-web/lib/components/MarketDataCardsComponent/MarketDataCardsContainer';

const layoutClasses = getBEMClasses('dashboard-page');

const MarketDataPage = () => (
  <React.Fragment>
    <div className={layoutClasses('accent-bar')} />
    <div className={layoutClasses()}>
      <MarketDataCardsContainer />
    </div>
    <div className={layoutClasses('footer')}>
      <PageFooterLayout />
    </div>
  </React.Fragment>
);

export default withAuthentication(MarketDataPage);
